<template>
  <div class="row">
    <hr />
    <div class="col-md-5">
      <div class="row">
        <div class="col-md-6">
          <label :title="title" :class="{ disabled: disabled }">
            <slot></slot>
          </label>
        </div>
        <div class="col-md-6 param-modifier-col">
          <span v-if="!disabled && optional" class="optional param-modifier"> optional </span>
          <span v-if="!disabled && error" class="validation-error param-modifier">
            {{ error }} </span
          ><span v-else-if="!disabled && !optional" class="param-modifier"> required </span>
        </div>
      </div>
      <input
        type="number"
        class="text field"
        :value="data.value"
        @input="
          data.value = $event.target.value;
          emitData();
        "
        :disabled="disabled"
      />
    </div>
    <div class="col-md-7 param-description">
      <slot name="description"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ParamInputNumber",
  model: {
    prop: "data",
    event: "change",
  },
  computed: {
    error: function () {
      return this.validator();
    },
    showElement: function () {
      return !this.optional || this.data.value;
    },
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    optional: Boolean,
    title: {
      type: String,
      default: "",
    },
    validator: {
      type: Function,
      default: function validator() {
        if (!this.optional && !this.data.value) {
          return "required";
        }
        return "";
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitData: function () {
      this.$emit("change", {
        value: this.data.value || "",
        error: this.error,
        optional: this.optional,
        varName: this.varName,
        showElement: this.showElement,
      });
    },
  },
  mounted: function () {
    this.varName = this.data.varName;
    this.emitData();
  },
  watch: {
    optional: function () {
      this.emitData();
    },
  },
};
</script>
